var _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgPdf = _ref => {
  let svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.2rem",
    height: "1.2rem",
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "Pdf"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "1.2rem",
    height: "1.2rem",
    fill: "white",
    fillOpacity: 0.01,
    style: {
      mixBlendMode: "multiply"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 5.5V4.5H11V11.5H12V8.5H14.5V7.5H12V5.5H15Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4.5H1V11.5H2V9H4C4.26522 9 4.51957 8.89464 4.70711 8.70711C4.89464 8.51957 5 8.26522 5 8V5.5C5 5.23478 4.89464 4.98043 4.70711 4.79289C4.51957 4.60536 4.26522 4.5 4 4.5ZM4 8H2V5.5H4V8Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11.5H6V4.5H8C8.53043 4.5 9.03914 4.71071 9.41421 5.08579C9.78929 5.46086 10 5.96957 10 6.5V9.5C10 10.0304 9.78929 10.5391 9.41421 10.9142C9.03914 11.2893 8.53043 11.5 8 11.5ZM7 10.5H8C8.26522 10.5 8.51957 10.3946 8.70711 10.2071C8.89464 10.0196 9 9.76522 9 9.5V6.5C9 6.23478 8.89464 5.98043 8.70711 5.79289C8.51957 5.60536 8.26522 5.5 8 5.5H7V10.5Z",
    fill: "#161616"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPdf, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Pdf.8bd1654b.svg";
export { ForwardRef as ReactComponent };